import api from '../config/api';

/**
 * Financial Statements Service - API client for internal GL financial statements
 * Handles Balance Sheet, Income Statement, Trial Balance, and Cash Flow Statement
 */

// ============================================================================
// TRIAL BALANCE
// ============================================================================

export const getTrialBalance = async (params = {}) => {
  const response = await api.get('/api/accounting/statements/trial-balance', { params });
  return response.data;
};

// ============================================================================
// BALANCE SHEET
// ============================================================================

export const getBalanceSheet = async (params = {}) => {
  const response = await api.get('/api/accounting/statements/balance-sheet', { params });
  return response.data;
};

// ============================================================================
// INCOME STATEMENT
// ============================================================================

export const getIncomeStatement = async (params = {}) => {
  const response = await api.get('/api/accounting/statements/income-statement', { params });
  return response.data;
};

// ============================================================================
// CASH FLOW STATEMENT
// ============================================================================

export const getCashFlowStatement = async (params = {}) => {
  const response = await api.get('/api/accounting/statements/cash-flow', { params });
  return response.data;
};

// ============================================================================
// TAGS
// ============================================================================

export const getTags = async () => {
  const response = await api.get('/api/accounting/tags');
  return response.data;
};

export const getTagSummary = async () => {
  const response = await api.get('/api/accounting/tags/summary');
  return response.data;
};

export const getEntriesByTag = async (tag, params = {}) => {
  const response = await api.get(`/api/accounting/journal-entries/by-tag/${encodeURIComponent(tag)}`, { params });
  return response.data;
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

export const formatCurrency = (value, currency = 'USD') => {
  const num = parseFloat(value) || 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatPercent = (value) => {
  const num = parseFloat(value) || 0;
  return `${num >= 0 ? '+' : ''}${num.toFixed(2)}%`;
};

// Export all functions as default object for convenience
const financialStatementsService = {
  getTrialBalance,
  getBalanceSheet,
  getIncomeStatement,
  getCashFlowStatement,
  getTags,
  getTagSummary,
  getEntriesByTag,
  formatCurrency,
  formatDate,
  formatPercent
};

export default financialStatementsService;
